import { DataLocationFileFormat, DataLocationStorageType } from '../views/DataSourceCreate/models/DataSourceDataCommon';
export const CosmosDataLocation = {
    DataPath: '',
    VC: '',
    Cluster: '',
};
export const AzureBlobLocation = {
    DataPath: '',
    StorageAccount: '',
    Container: '',
};
export const ADLSGen2Location = {
    DataPath: '',
    StorageAccount: '',
    Container: '',
    Url: '',
    SecretName: '',
};
export const MTLocation = [
    {
        Region: '',
        DataPath: '',
        EndPoint: '',
        required: {
            DataPath: 'Required',
            EndPoint: 'Required',
        },
    },
];
export const DataLocationDataType = {
    CosmosCosmosView: `${DataLocationStorageType.Cosmos}-${DataLocationFileFormat.CosmosView}`,
    AzureBlobParquet: `${DataLocationStorageType.AzureBlob}-${DataLocationFileFormat.Parquet}`,
    ADLSGen2Parquet: `${DataLocationStorageType.ADLSGen2}-${DataLocationFileFormat.Parquet}`,
    MTParquet: `${DataLocationStorageType.MT}-${DataLocationFileFormat.Parquet}`,
    ADLSGen2CosmosView: `${DataLocationStorageType.ADLSGen2CosmosView}-${DataLocationFileFormat.CosmosView}`,
};

//# sourceMappingURL=DataSource.DataLocation.constants.js.map
